//adding rte-content class to default rte divs
if(window.location.pathname.indexOf('/policies/') !== -1) {
  let rte_divs = document.querySelectorAll('.rte');
  rte_divs.forEach((ele) => {
    ele.classList.add('rte-content');
  });
}

$(document).ready(function(){
  $(".subscribe-faq .faq-accordion-inner").click(function () {
      $(this).parent(".lists_col").toggleClass('active').find(".faq-accordion-values").slideToggle();
      $(this).parent(".lists_col").prevAll(".lists_col").removeClass('active').find(".faq-accordion-values").slideUp();
      $(this).parent(".lists_col").nextAll(".lists_col").removeClass('active').find(".faq-accordion-values").slideUp();
  });
});